"use strict";

exports.__esModule = true;
exports.IFrameThumbnail = IFrameThumbnail;
var _react = _interopRequireDefault(require("react"));
var _TextValue = require("../../Measures/TextValue");
var _common = require("../common");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
/**
 * Thumbnail for IFrameWidget.
 */
function IFrameThumbnail(props) {
  var _props$x = props.x,
    x = _props$x === void 0 ? 0 : _props$x,
    _props$y = props.y,
    y = _props$y === void 0 ? 0 : _props$y,
    urlTemplate = props.urlTemplate;
  return /*#__PURE__*/_react["default"].createElement(_TextValue.TextValue, _extends({
    value: urlTemplate,
    color: "#0000EE"
  }, (0, _common.getWidgetPositionProps)(Object.assign({}, props, {
    x: x,
    y: y
  })), (0, _common.getWidgetInteractionProps)(props)));
}